import React, { useState, useEffect } from 'react';
import { View, StyleSheet, ActivityIndicator } from 'react-native';
import { Text, Card, Button, Icon } from '@rneui/themed';
import { useRoute } from '@react-navigation/native';
import { useAuth } from '../config/AuthContext';
import config from '../config/config';

export function ProducaoScreen() {
  const route = useRoute();
  const { deviceName } = route.params;
  // const azureUrl = 'http://localhost:3001/api';
  const tableName = 'equipstates';
  const { maquinaId } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  const [tipoMaq, setTipoMaq] = useState({});
  const [prodInfo, setProdInfo] = useState({});
  const [prodSup, setProdSup] = useState({});
  const [prodAtual, setProdAtual] = useState({});
  const [velocEst, setVelocidade] = useState({});
  const [qtdeDesc, setQtdeDesc] = useState({});

  const [ultComp, setUltComp] = useState({});
  const [ultLargMin, setUltLargMin] = useState({});
  const [ultLargMed, setUltLargMed] = useState({});
  const [ultLargMax, setUltLargMax] = useState({});
  const [ultEspMin, setUltEspMin] = useState({});
  const [ultEspMed, setUltEspMed] = useState({});
  const [ultEspMax, setUltEspMax] = useState({});
  const [fatorCone, setFatorCone] = useState({});

  useEffect(() => {
    fetchData()
      .then(() => {
        setIsLoading(false); // Quando os dados estiverem prontos, desativar o indicador de carregamento
      })
      .catch((error) => {
        console.log(`Erro ao listar dados: ${error.message}`);
        setIsLoading(false); // Certifique-se de desativar o indicador de carregamento mesmo em caso de erro
      });

    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, []);

  async function fetchData() {
    try {
      const tabelaEndpoint = `${config.apiBaseUrl}/tables/${tableName}?$filter=maquinaId eq '${maquinaId}'`;
      const response = await fetch(tabelaEndpoint, {
        headers: {
          'ZUMO-API-VERSION': '2.0.0',
        },
      });

      const data = await response.json();
      const parsedData = JSON.parse(data[0].dados);

      const tipoMaq = parsedData
        .filter((item) => item.Nome == deviceName)
        .map((item) => item.TipoMaq);
      setTipoMaq(tipoMaq);

      const prodInfo = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.ProdInf);
      setProdInfo(prodInfo);

      const prodSup = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.ProdSup);
      setProdSup(prodSup);

      const prodAtual = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.ProdAtual);
      setProdAtual(prodAtual);

      const velocEst = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.Veloc);
      setVelocidade(velocEst);

      const qtdeDesc = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.QtdeDesc);
      setQtdeDesc(qtdeDesc);

      const ultComp = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.UltComp);
      setUltComp(ultComp);

      const ultLargMin = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.UltLargMin);
      setUltLargMin(ultLargMin);

      const ultLargMed = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.UltLargMed);
      setUltLargMed(ultLargMed);

      const ultLargMax = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.UltLargMax);
      setUltLargMax(ultLargMax);

      const ultEspMin = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.UltEspMin);
      setUltEspMin(ultEspMin);

      const ultEspMed = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.UltEspMed);
      setUltEspMed(ultEspMed);

      const ultEspMax = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.UltEspMax);
      setUltEspMax(ultEspMax);

      const fatorCone = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.FatorCone);
      setFatorCone(fatorCone);
    } catch (error) {
      console.log(`Erro ao listar dados: ${error.message}`);
    }
  }

  const tipoMaqParsed = parseInt(tipoMaq);
  let viewToRender;

  if (tipoMaqParsed === 0 || tipoMaqParsed === 1) {
    viewToRender = (
      <View style={{ padding: 30 }}>
        <View style={[styles.cardContainer, { marginBottom: 20 }]}>
          <Text style={styles.textCard}>Velocidade Esteira</Text>
          <Text style={{ fontSize: 24, alignSelf: 'center' }}>
            {velocEst[0]}
          </Text>
        </View>
        <View style={styles.cardContainer}>
          <Text style={styles.textCard}>Qtde / Descarte</Text>
          <Text style={{ fontSize: 24, alignSelf: 'center' }}>
            {qtdeDesc[0]}
          </Text>
        </View>
      </View>
    );
  } else if (tipoMaqParsed === 2) {
    viewToRender = (
      <View style={{ padding: 10 }}>
        <View
          style={[styles.cardContainer, { width: 330, alignSelf: 'center' }]}
        >
          <Text style={styles.textCard}>Velocidade Esteria</Text>
          <Text style={{ fontSize: 22, alignSelf: 'center' }}>
            {velocEst[0]}
          </Text>
        </View>
        <View style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
          <View style={[styles.cardContainer, { width: 150 }]}>
            <Text style={styles.textCard}>Comprimento</Text>
            <Text style={{ fontSize: 22, alignSelf: 'center' }}>
              {ultComp[0]}
            </Text>
          </View>
          <View style={[styles.cardContainer, { width: 150 }]}>
            <Text style={styles.textCard}>Qtde / Descarte</Text>
            <Text style={{ fontSize: 22, alignSelf: 'center' }}>
              {qtdeDesc[0]}
            </Text>
          </View>
        </View>
        <View style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
          <View style={[styles.cardContainer, { width: 150 }]}>
            <Text style={styles.textCard}>Largura MIN</Text>
            <Text style={{ fontSize: 22, alignSelf: 'center' }}>
              {ultLargMin[0]}
            </Text>
          </View>
          <View style={[styles.cardContainer, { width: 150 }]}>
            <Text style={styles.textCard}>Espessura MIN</Text>
            <Text style={{ fontSize: 22, alignSelf: 'center' }}>
              {ultEspMin[0]}
            </Text>
          </View>
        </View>
        <View style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
          <View style={[styles.cardContainer, { width: 150 }]}>
            <Text style={styles.textCard}>Largura MED</Text>
            <Text style={{ fontSize: 22, alignSelf: 'center' }}>
              {ultLargMed[0]}
            </Text>
          </View>
          <View style={[styles.cardContainer, { width: 150 }]}>
            <Text style={styles.textCard}>Espessura MED</Text>
            <Text style={{ fontSize: 22, alignSelf: 'center' }}>
              {ultEspMed[0]}
            </Text>
          </View>
        </View>
        <View style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
          <View style={[styles.cardContainer, { width: 150 }]}>
            <Text style={styles.textCard}>Largura MAX</Text>
            <Text style={{ fontSize: 22, alignSelf: 'center' }}>
              {ultLargMax[0]}
            </Text>
          </View>
          <View style={[styles.cardContainer, { width: 150 }]}>
            <Text style={styles.textCard}>Espessura MAX</Text>
            <Text style={{ fontSize: 22, alignSelf: 'center' }}>
              {ultEspMax[0]}
            </Text>
          </View>
        </View>
      </View>
    );
  } else {
    viewToRender = (
      <View style={{ padding: 10 }}>
        <View
          style={[styles.cardContainer, { width: 330, alignSelf: 'center' }]}
        >
          <Text style={styles.textCard}>Velocidade Esteria</Text>
          <Text style={{ fontSize: 22, alignSelf: 'center' }}>
            {velocEst[0]}
          </Text>
        </View>
        <View style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
          <View style={[styles.cardContainer, { width: 150 }]}>
            <Text style={styles.textCard}>Comprimento</Text>
            <Text style={{ fontSize: 22, alignSelf: 'center' }}>
              {ultComp[0]}
            </Text>
          </View>
          <View style={[styles.cardContainer, { width: 150 }]}>
            <Text style={styles.textCard}>Diametro MIN</Text>
            <Text style={{ fontSize: 22, alignSelf: 'center' }}>
              {ultLargMin[0]}
            </Text>
          </View>
        </View>
        <View style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
          <View style={[styles.cardContainer, { width: 150 }]}>
            <Text style={styles.textCard}>Qtde/ Descarte</Text>
            <Text style={{ fontSize: 22, alignSelf: 'center' }}>
              {qtdeDesc[0]}
            </Text>
          </View>
          <View style={[styles.cardContainer, { width: 150 }]}>
            <Text style={styles.textCard}>Diametro MED</Text>
            <Text style={{ fontSize: 22, alignSelf: 'center' }}>
              {ultLargMed[0]}
            </Text>
          </View>
        </View>
        <View style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
          <View style={[styles.cardContainer, { width: 150 }]}>
            <Text style={styles.textCard}>Conicidade</Text>
            <Text style={{ fontSize: 22, alignSelf: 'center' }}>
              {fatorCone[0]}
            </Text>
          </View>
          <View style={[styles.cardContainer, { width: 150 }]}>
            <Text style={styles.textCard}>Diametro MAX</Text>
            <Text style={{ fontSize: 22, alignSelf: 'center' }}>
              {ultLargMax[0]}
            </Text>
          </View>
        </View>
      </View>
    );
  }

  let backgroundColor = '#F3F3F1'; // Cor padrão do card

  if (prodAtual[0] < prodInfo[0]) {
    backgroundColor = '#E20000';
  } else if (prodAtual[0] >= prodSup[0]) {
    backgroundColor = '#198A07';
  } else {
    backgroundColor = '#FFD329';
  }

  if (isLoading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#0081CF" />
      </View>
    );
  }
  return (
    <View style={styles.container}>
      <View
        style={[
          styles.cardContainer,
          { backgroundColor },
          { width: 330, alignSelf: 'center' },
        ]}
      >
        <Text style={{ fontSize: 20, alignSelf: 'center' }}>
          Produção / Minuto
        </Text>
        <Text style={{ fontSize: 22, alignSelf: 'center' }}>
          {prodAtual[0]}
        </Text>
      </View>
      <View>{viewToRender}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#CCCCCA',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardContainer: {
    backgroundColor: '#F3F3F1', //fundo do card
    borderRadius: 5,
    width: 200,
    marginBottom: 10,
  },
  textCard: {
    fontSize: 18,
    alignSelf: 'center',
    color: '#0081CF',
    paddingBottom: 2,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#CCCCCA',
  },
});
